import WidgetModule from "@eisinc/Overrides/Widgets/Requisitions/RequisitionsRequisitionLinesTable";

export * from "@eisinc/Overrides/Widgets/Requisitions/RequisitionsRequisitionLinesTable";

export default WidgetModule;
